import React from "react";
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import classes from "../../styling/components/demo/DemoMailOverviewCard.module.css";
import {DemoDispatch} from "../../model/DemoDispatch";
import CheckCircleOutlineIcon from "@mui/icons-material/Check";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

interface Props {
    demoMail: DemoDispatch;
    onClick?: () => void;
    onLearningPageClick?: () => void;
}

export const DemoMailOverviewCard: React.FC<Props> = (props) => {
    const {demoMail, onClick, onLearningPageClick} = props;
    const {t, i18n} = useTranslation();

    return (
        <div
            className={`${classes.mailRow} ${demoMail.clicked ? classes.mailRowClicked : classes.mailRowNotClicked}`}
        >
            <div className={classes.topRow}>
                <div className={classes.subjectSection}>
                    {demoMail.subject}
                </div>
                <div className={classes.clickedBadge}>
                    <span className={demoMail.clicked ? classes.clicked : classes.notClicked}>
                        {demoMail.clicked ? (
                            <>
                                <ReportProblemIcon className={classes.statusIcon} fontSize="small"/>
                                {t('demoMail.clicked', 'Clicked')}
                            </>
                        ) : (
                            <>
                                <CheckCircleOutlineIcon className={classes.statusIcon} fontSize="small"/>
                                {t('demoMail.notClicked', 'Not Clicked')}
                            </>
                        )}
                    </span>
                </div>
            </div>
            <div className={classes.mailMetadata}>
                <div className={classes.metadataItem}>
                    <strong>{t('demoMail.sent', 'Sent')}:</strong> {new Date(demoMail.sentAt).toLocaleString(i18n.language, {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit"
                    })}
                </div>
                <div className={classes.metadataItem}>
                    <strong>{t('demoMail.sender', 'Sender')}:</strong> {demoMail.sender}
                </div>
            </div>
            {(onClick || onLearningPageClick) && (
                <div className={classes.actions}>
                    {onClick && (
                        <Button
                            size="small"
                            variant="contained"
                            onClick={onClick}
                            color="look2xBlue"
                        >
                            {t('demoMail.viewMail', 'View Mail')}
                        </Button>
                    )}
                    {onLearningPageClick && (
                        <Button
                            size="small"
                            variant="contained"
                            onClick={onLearningPageClick}
                            color="look2xBlue"
                        >
                            {t('demoMail.viewLearningPage', 'View Learning Page')}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};
